import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupGroupsLabsEditRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/groups_labs/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/group/GroupsLabs/GroupGroupsLabsEditPage/GroupGroupsLabsEditPage').then(
    (d) => d.Route
  )
);
